export default {
  // ローカルストレージのキー
  localStorage: {
    // 録音した
    recorded: 'recorded',
  },

  // cookieのキー名
  cookieName: {
    isTutorialSkip: 'is_tutorial_skip',
    audioLatencyAdjust: 'audio_latency_adjust',
  },

  // 1秒あたりのトラックの幅
  trackWidthPerSecond: 200,
}
